import axios from "axios";

// In dev, CRA's "proxy" field (see package.json) forwards this to the local
// Flask server. In production, Flask serves both the built frontend and the
// API from the same origin, so a relative base URL works unchanged.
const instanceFlask = axios.create({
  baseURL: "/api"
});

// Attach a fresh Azure AD access token (acquired via MSAL) to every request,
// mirroring the pattern used by the `rmp` app's axiosConfig.js. Imported
// lazily to avoid a circular import between msalInstance/AuthContext/this file.
instanceFlask.interceptors.request.use(
  async (config) => {
    try {
      const { msalInstance, msalSettings } = await import("../msalInstance");
      if (msalInstance && msalSettings.isConfigured) {
        const accounts = msalInstance.getAllAccounts();
        const account = msalInstance.getActiveAccount() || accounts[0];
        if (account) {
          const response = await msalInstance.acquireTokenSilent({
            scopes: msalSettings.scopes,
            account
          });
          if (response?.accessToken) {
            config.headers["Authorization"] = "Bearer " + response.accessToken;
          }
        }
      }
    } catch (error) {
      console.warn("Failed to acquire token for Flask request", error);
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Surface auth failures (invalid/expired token, disallowed domain) so the
// auth layer can react (e.g. show the sign-in screen again).
instanceFlask.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      window.dispatchEvent(
        new CustomEvent("app:auth-error", {
          detail: { message: error.response.data?.message }
        })
      );
    }
    return Promise.reject(error);
  }
);

export { instanceFlask };
